module.exports = __webpack_public_path__ + "img/ifc.340ca022.png";